export const productTypes = {
  catalogue: 'catalogue',
  common: 'common',
  'dashboard-bg': 'dashboard-bg',
  'dashboard-sm': 'dashboard-sm',
  detailsPage: 'detailsPage',
  article: 'article',
};
